// extracted by mini-css-extract-plugin
export var container = "_37-0";
export var error = "_37-9";
export var label = "_37-5";
export var light = "_37-6";
export var md = "_37-3";
export var sm = "_37-2";
export var thin = "_37-8";
export var thinBold = "_37-7";
export var vertical = "_37-4";
export var xs = "_37-1";